<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <TopDashboardsPanel
          name-dashbords="Клиентские отчеты"
        ></TopDashboardsPanel>
        <DashboardsViewForm
          :store="workbooksStore"
          type="client_workbook"
        ></DashboardsViewForm>
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopDashboardsPanel from "@/entities/analytics/dashboards/TopDashboardsPanel.vue";
import DashboardsViewForm from "@/entities/analytics/dashboards/DashboardsViewForm.vue";

import { useAuthStore } from "@/store/auth/login";
import { useClientWorkbooksStore } from "@/store/catalog_data/client_reports";

const authStore = useAuthStore();
const workbooksStore = useClientWorkbooksStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["analytics:read", "analytics:edit"],
    ["external_agency:read", "external_agency:edit"]
  );
});
</script>
